import React, { useState } from 'react';

import { Input, Form } from 'antd';

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const PasswordResetForm = (_, ref) => {
  const [readOnly, setReadOnly] = useState(true);

  const enablePasswordField = () => {
    setTimeout(() => setReadOnly(false), 300);
  };

  const disableAutoFill = () => {
    setReadOnly(true);
    enablePasswordField();
  };

  const passwordChanged = (e) => {
    if (e.target.value.trim().length === 0) {
      disableAutoFill();
    }
  };
  return (
    <Form
      name="basic"
      className="gx-form-row0"
      ref={ref}
      {...formItemLayout}
      autoComplete="off"
    >
      <Form.Item
        rules={[
          { required: true, message: 'This input is required!' },
        ]}
        label="Set Password"
        name="password"
      >
        <Input onChange={passwordChanged} onContextMenu={(e) => e.preventDefault()} onClick={disableAutoFill} readOnly={readOnly} onFocus={enablePasswordField} type="password" placeholder="Password" autoComplete="off" />
      </Form.Item>
      <Form.Item
        rules={[
          { required: true, message: 'This input is required!' },
        ]}
        label="Confirm Password"
        name="passwordAgain"
      >
        <Input onChange={passwordChanged} onContextMenu={(e) => e.preventDefault()} onClick={disableAutoFill} readOnly={readOnly} onFocus={enablePasswordField} type="password" placeholder="Password" autoComplete="off" />
      </Form.Item>
    </Form>
  );
};

export default React.forwardRef(PasswordResetForm);
